export const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_ACCEPTABLE: 488,
  INTERNAL_ERROR: 500,
  NOT_FOUND: 404,
  NETWORKERROR: 0,
  RATE_LIMIT: 429,
  BAD_REQUEST: 400
};
export const ERROR_STATUS_CODES = {
  NETWORKERROR: 'NETWORKERROR',
  ABORT: 'ABORT'
};
export const RETRY_MIDDLEWARE_ATTEMPTS_AMOUNT = 3;
export const HTTP_READY_STATE = {
  UNSENT: 0,
  OPENED: 1,
  HEADERS_RECEIVED: 2,
  LOADING: 3,
  DONE: 4
};
export const COMMON_HTTP_MESSAGES = {
  REQUEST_ABORTED: 'Request aborted'
};
export const DEBOUNCE_TIME = 300;